'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fontSizeSm = '12px';
var fontSizeBase = '14px';
var fontSizeLg = '16px';
exports.default = {
  fontSizeSm: fontSizeSm,
  fontSizeBase: fontSizeBase,
  fontSizeLg: fontSizeLg
};